var _rect, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 300,
    fill: "#E3F2FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 50,
    fill: "#90CAF9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 400,
    y2: 50,
    stroke: "#64B5F6",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 400,
    y2: 100,
    stroke: "#BBDEFB",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 400,
    y2: 150,
    stroke: "#BBDEFB",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 400,
    y2: 200,
    stroke: "#BBDEFB",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 250,
    x2: 400,
    y2: 250,
    stroke: "#BBDEFB",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 50,
    x2: 100,
    y2: 300,
    stroke: "#64B5F6",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 50,
    x2: 200,
    y2: 300,
    stroke: "#64B5F6",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 50,
    x2: 300,
    y2: 300,
    stroke: "#64B5F6",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.cd9e75a3808a1f64270cac1a8030de30.svg";
export { ForwardRef as ReactComponent };